import * as React from 'react'

import { type VariantProps, cva } from 'class-variance-authority'

import { cn } from '@/shared/lib/styles/class-merge'

const inputVariants = cva(
    'flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
    {
        variants: {
            inputSize: {
                default: 'h-10 text-base md:text-sm',
                xs: 'h-6 text-xs rounded-sm px-2 py-1',
                sm: 'h-8 text-xs rounded-md',
                lg: 'h-12 text-base rounded-md',
            },
        },
        defaultVariants: {
            inputSize: 'default',
        },
    },
)

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, inputSize, ...props }, ref) => {
    return <input type={type} className={cn(inputVariants({ inputSize, className }))} ref={ref} {...props} />
})
Input.displayName = 'Input'

export { Input, inputVariants }
